var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
      _vm.colorType === 'main' ? _vm.styles.btn_main_icon : _vm.styles.btn_secondary_icon,
      { 'md:hover:scale-110 transition duration-300 ease-out': _vm.transform && _vm.anim }
      ],attrs:{"disabled":_vm.load}},[(_vm.load)?_c('my-loader'):_c('BaseIcon',{attrs:{"icon":_vm.icon,"size":_vm.sizeIcon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }